<template>
  <!-- 搜索结果页面---右侧列表 -->
  <div class="searchResult_rightmain">
    <div class="headerContent">
      <div class="header_top_warp">
        <ul>
          <li class="headerTopWarp_toal">
            共找到
            <span>{{rightMainList.total}}</span> 篇文章
          </li>
          <li>
            <button
              @click="invalidStillRelevantFn(2)"
              :class="form.invalidStillRelevant==2?'buttom_style':''"
            >
              <img
                v-show="form.invalidStillRelevant==2?true:false"
                src="@/assets/ewnzhangliebiao_shi2.png"
                alt
              />
              <img
                v-show="form.invalidStillRelevant==2?false:true"
                src="@/assets/ewnzhangliebiao_shi1.png"
                alt
              />
              时效性
            </button>
            <button
              @click="invalidStillRelevantFn(1)"
              :class="form.invalidStillRelevant==1?'buttom_style':''"
            >
              <img
                v-show="form.invalidStillRelevant==1?true:false"
                src="@/assets/ewnzhangliebiao_shi2.png"
                alt
              />
              <img
                v-show="form.invalidStillRelevant==1?false:true"
                src="@/assets/ewnzhangliebiao_shi1.png"
                alt
              />
              相关度
            </button>
          </li>
        </ul>
      </div>
      <div class="header_bottom_warp">
        <ul>
          <!-- 全选加入授权功能 -->
          <!-- <li @click="selectAllfun()">
            <div
              :style="{borderColor:selectAll==1?'rgba(21, 47, 106, 1)':'rgba(204,204,204,1)',backgroundColor:selectAll==1?'rgba(21, 47, 106, 1)':''}"
            >
              <img src="@/assets/duiHao.png" alt />
            </div>全选
          </li>
          <div class="addclub" @click="joinauthorization">加入授权</div>-->
          <el-dialog :visible.sync="sqShow" width="400px" :show-close="false">
            <div class="sqtxt">12篇位置已加入待授权</div>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" class="sqbox" @click="sqShow = false">确 定</el-button>
            </span>
          </el-dialog>
        </ul>
        <ul>
          <!-- <li @click="authorization(1)">
            <div
              :style="{borderColor:form.authorizationnumber==1?'rgba(21, 47, 106, 1)':'rgba(204,204,204,1)',backgroundColor:form.authorizationnumber==1?'rgba(21, 47, 106, 1)':''}"
            >
              <img src="@/assets/duiHao.png" alt />
            </div>已授权
          </li>-->
          <li @click="authorization(2)">
            <div
              :style="{borderColor:form.authorizationnumber==2?'rgba(21, 47, 106, 1)':'rgba(204,204,204,1)',backgroundColor:form.authorizationnumber===2?'rgba(21, 47, 106, 1)':''}"
            >
              <img src="@/assets/duiHao.png" alt />
            </div>未授权
          </li>
          <li @click="audioRightsnth(1)">
            <div
              :style="{borderColor:form.audioRights==1?'rgba(21, 47, 106, 1)':'rgba(204,204,204,1)',backgroundColor:form.audioRights===1?'rgba(21, 47, 106, 1)':''}"
            >
              <img src="@/assets/duiHao.png" alt />
            </div>音频转授
          </li>
          <li @click="layoutFn(1)">
            <div
              :style="{borderColor:form.layout==1?'rgba(21, 47, 106, 1)':'rgba(204,204,204,1)',backgroundColor:form.layout==1?'rgba(21, 47, 106, 1)':''}"
            >
              <img src="@/assets/duiHao.png" alt />
            </div>有配图
          </li>
          <li @click="layoutFn(2)">
            <div
              :style="{borderColor:form.layout==2?'rgba(21, 47, 106, 1)':'rgba(204,204,204,1)',backgroundColor:form.layout==2?'rgba(21, 47, 106, 1)':''}"
            >
              <img src="@/assets/duiHao.png" alt />
            </div>无配图
          </li>
        </ul>
      </div>
    </div>
    <div class="mainContent">
      <contentList
        :addCallBack="addCallBack"
        contentWidth="630px"
        :list="rightMainList.article"
        :selectAll="this.selectAll"
        @dotsel="dotdel_"
      />
    </div>

    <pagination @no-change-pagination="noChangePagination" :pages="totalnum" />
  </div>
</template>

<script>
import contentList from "@/components/common/contentList/index.vue";
import pagination from "@/components/common/pagination/index.vue";
// import store from "@/store";
export default {
  name: "searchResultComponent",
  props: {
    rightMainList: {
      // type: Array,
      default: ""
    },
    pages: {
      type: Number,
      default: 0
    },
    parentAddCallBack: {
      type: Function,
      default: undefined
    }
  },

  data() {
    return {
      selectAll: 0,
      sqShow: false,
      form: {
        invalidStillRelevant: 2, //选择的是失效性还是相关度 0=都不选 1=时效性 2=相关度
        layout: 0, //有无配图  都不选=0 有=1 无=2
        audioRights: "", //1:有授权音频;0:无授权音频，默认””
        authorizationnumber: "", //1:有授权;0:无授权，默认””
        page: {
          page: 1, //当前第几页
          pageSize: 10, //每页几条
          pages: 20 //总共条数
        }
      },
      pageData: [5, 10, 15],
      contentListdata: []
    };
  },
  computed: {
    totalnum() {
      return this.pages;
    }
  },
  methods: {
    addCallBack () {
      if (this.parentAddCallBack ) {
      this.parentAddCallBack() 
      }
    },
    joinauthorization() {
      this.sqShow = true;
    },
    noChangePagination(res) {
      console.log(res);
      this.rightMainList.article = [];
      console.log(res.data);
      this.form.page = res.data;
      this.emitForm();
      this.selectAll = res.dotdel_;
    },
    dotdel_(res) {
      this.selectAll = res;
    },
    // 全选
    selectAllfun() {
      if (this.selectAll != 1) {
        this.selectAll = 1;
      } else {
        this.selectAll = 0;
      }
    },
    invalidStillRelevantFn(res) {
      // this.form.invalidStillRelevant = Number(res);
      //选择 时效性 还是 相关度 方法
      if (this.form.invalidStillRelevant !== Number(res)) {
        this.form.invalidStillRelevant = Number(res);
        this.form.page.page = 1;
        this.rightMainList.article = [];
        this.emitForm();
      } else {
        // this.form.invalidStillRelevant = 0;
      }
      // this.emitForm();
    },
    layoutFn(res) {
      this.rightMainList.article = [];
      this.form.page.page = 1;
      //选择 有图 无图 的方法
      if (this.form.layout !== Number(res)) {
        this.form.layout = Number(res);
      } else {
        this.form.layout = 0;
      }
      this.emitForm();
    },
    authorization(res) {
      this.rightMainList.article = [];
      this.form.page.page = 1;
      //选择 有图 无图 的方法
      if (this.$store.state.userInfo.unique_code) {
        if (this.form.authorizationnumber !== Number(res)) {
          this.form.authorizationnumber = Number(res);
        } else {
          this.form.authorizationnumber = "";
        }
        this.emitForm();
      } else {
        this.$message.warning("请先登录");
        this.$router.push({ path: "/login" });
      }
    },
    audioRightsnth(res) {
      this.rightMainList.article = [];
      this.form.page.page = 1;
      if (this.$store.state.userInfo.unique_code) {
        if (this.form.audioRights !== Number(res)) {
          this.form.audioRights = Number(res);
        } else {
          this.form.audioRights = "";
        }
        this.emitForm();
      } else {
        this.$message.warning("请先登录");
        this.$router.push({ path: "/login" });
      }
      //选择音频转授的方法
    },
    emitForm() {
      console.log(this.form);
      //向父级传参数
      this.$emit("no-getData", {
        data: this.form,
        messages: {
          layout: "选择有配图无配图返回参数(都不选=0 有配图=1 无配图=2)",
          invalidStillRelevant:
            "选择失效性还是相关度返回参数：0=都不选 1=时效性 2=相关度",
          audioRights: "", //1:有授权音频;0:无授权音频，默认””
          authorizationnumber: "", //1:有授权;0:无授权，默认””
          page: {
            page: "当前第几页",
            pageSize: "每页几条",
            pages: "总共条数"
          }
        }
      });
    }
  },
  mounted() {
    // setTimeout(()=>{
    // this.form.page.pages = this.pages;

    // // alert(this.pages)
    // },500)
    this.emitForm();
  },
  components: {
    contentList,
    pagination
  }
};
</script>
<style>
.el-dialog {
  border-radius: 12px;
  padding-bottom: 20px;
}
</style>
<style scoped>
.sqbox {
  width: 300px;
  height: 40px;
  background: rgba(21, 47, 106, 1);
  border-radius: 4px;
  border: none;
  display: block;
  margin: 0 auto;
}
.sqtxt {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  text-align: center;
}
</style>
<style scoped lang="less">
.searchResult_rightmain {
  width: 800px;
  // height:966px;
  padding: 0 0 40px 0;
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  .headerContent {
    .header_top_warp {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      ul {
        display: flex;
        align-items: center;
        height: 60px;
        justify-content: space-between;
        li {
          padding: 0 40px;
          font-weight: 500;
          font-size: 18px;
          span {
            color: rgb(59, 107, 246);
          }
          button {
            width: 92px;
            height: 24px;
            line-height: 24px;
            border-radius: 4px;
            transition: 0.2s;
            border: 1px solid rgba(21, 47, 106, 1);
            outline: none;
            font-size: 12px;
            background: #ffffff;
            font-weight: 400;
            display: flex;
            align-items: center;
            color: rgba(21, 47, 106, 1);
            img {
              height: 20px;
              width: 20px;
              margin: 0 8px;
            }
          }
          .buttom_style {
            background: rgba(21, 47, 106, 1);
            color: #ffffff;
          }
          button:hover {
            background: #214da6;
            color: #fff;
          }
          button:hover img:last-child {
            display: none !important;
          }
          button:hover img:first-child {
            display: inline !important;
          }
        }
        li:last-child {
          display: flex;
          width: 204px;
          justify-content: space-between;
        }
      }
    }
    .header_bottom_warp {
      padding: 0 40px 0 0;
      display: flex;
      justify-content: space-between;
      .addclub {
        width: 68px;
        background: rgba(21, 47, 106, 1);
        border-radius: 4px;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
        text-align: center;
        margin-left: 20px;
      }
      ul {
        display: flex;
        align-items: center;
        height: 60px;
        justify-content: flex-end;
        li {
          cursor: pointer;
          margin-left: 20px;
          display: flex;
          div {
            width: 18px;
            height: 18px;
            transition: 0.2s;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            margin-right: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid rgba(204, 204, 204, 1);
            img {
              height: 12px;
            }
          }
        }
      }
    }
  }
  .mainContent {
  }
  .footerContent {
    padding: 44px 40px 0 40px;
    display: flex;
    justify-content: space-between;
    .footerLeftPage {
      height: 30px;
      display: flex;
      align-items: center;
      p {
        width: 30px;
        height: 30px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(204, 204, 204, 1);
        line-height: 30px;
        border-radius: 4px;
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
        border: 1px solid rgba(204, 204, 204, 1);
      }
      .p_active {
        background-color: rgba(21, 47, 106, 1);
        border: 1px solid rgba(21, 47, 106, 1);
        color: #ffffff;
      }
    }
  }
}
.headerTopWarp_toal {
  font-size: 14px !important;
}
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: rgba(21, 47, 106, 1);
  border: none;
  color: #fff;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: rgba(21, 47, 106, 1);
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  background-color: rgba(21, 47, 106, 1);
  border: none;
  color: #fff;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  /* background-color:none!important;  */
  background: none;
  border: 1px solid rgba(204, 204, 204, 1);
  border-radius: 4px;
}
/* .el-pager .active{
  background:red
} */
.el-pager li {
  height: 30px;
  line-height: 30px;
  /* main-width:30px; */
}
</style>



// WEBPACK FOOTER //
// src/page/searchResult/searchResultComponents/rightMain.vue